import styled from "styled-components";

export const UploadDocWrapper = styled.div`
	padding: 20px 10px;
	border-radius: 15px;
	background: var(--main-explosive-gradient-020);
	display: flex;
	width: 100%;
	height: 100%;
	justify-content: space-between;
	align-items: center;

	@media (min-width: 428px) {
		min-height: 90px;
		margin-bottom: 16px;
	}
	@media (min-width: 1024px) {
		padding-bottom: 20px;
		border-bottom: 1px solid var(--main-explosive);
	}

	.ant-btn {
		background-color: var(--main-explosive);
		font-size: 16px;
		color: var(--main-text-color);
		width: 100px;
		line-height: 40px;
		text-align: center;
		padding: 0;
		font-weight: 600;
		cursor: pointer;

		&:hover,
		&:focus,
		&:active {
			background: #4e4b66 !important;
			color: #fcfcfc !important;
			opacity: 0.8;
		}

		&:disabled {
			background: #4e4b66 !important;
			color: #fcfcfc !important;
			opacity: 0.6;
		}

		@media (min-width: 428px) {
			height: 50px;
			line-height: 50px;
			font-size: 22px;
			width: 140px;
		}
		@media (min-width: 1024px) {
			height: 40px;
			line-height: 40px;
			font-size: 18px;
		}
	}
`;

export const DocNameWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	color: var(--main-text-color);
	line-height: 20px;
	text-transform: uppercase;
	width: calc(100% - 100px);
	@media (min-width: 428px) {
		line-height: 25px;
		width: calc(100% - 140px);
	}
	@media (min-width: 1024px) {
		line-height: 20px;
	}
`;

export const DocName = styled.div`
	color: #eff0f6;
	font-size: 16px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.75px;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: pre;
`;

export const DocStatus = styled.div`
	color: #a0a3bd;
	font-size: 12px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.3px;
	&.accepted {
		color: #18bb0c;
	}
	&.rejected {
		color: #f0052f;
		.upload-again-text {
			color: #a0a3bd;
			font-size: 10px;
			font-weight: 400;
			line-height: 12px;
			letter-spacing: 0.25px;
			margin-left: 5px;
		}
	}
`;

export const DocDescription = styled.div`
	color: #a0a3bd;
	font-size: 11px;
	font-weight: 400;
	line-height: 16px;
	letter-spacing: 0.2px;
	opacity: 0.8;
`;

export const UploadBtnWrapper = styled.div`
	.ant-btn {
		display: flex;
		height: 30px;
		padding: 0px 10px;
		justify-content: center;
		align-items: center;
		gap: 5px;
		border-radius: 50px;
		background: #4e4b66;
		color: #fcfcfc;
		text-align: center;
		font-size: 10px !important;
		font-weight: 600;
		line-height: 12px;
		letter-spacing: 0.3px;
	}
`;

export const DocumentsContainer = styled.div`
	&.cube-form-wrapper {
		.ant-form-item {
			width: auto;
			margin-bottom: 0px;
			@media (min-width: 768px) {
				margin-bottom: 4px;
			}
		}
		.ant-picker {
			width: 100%;
		}
		.ant-btn {
			min-width: 100%;
			font-size: 14px;
		}
		.ant-input-disabled {
			background: var(--dark) !important;
			color: var(--disabled-gray) !important;
		}
	}
	&.doc-padding {
		display: flex;
		flex-direction: column;
		gap: 10px;
	}
`;
